import { Button, Flex, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { updateChoice } from "areas/product/store/actions"
import { closeModal } from "components/modal"
import { imageLookup } from "helpers/product/image-lookup"
import { storePref } from "helpers/user-prefs"

const Categories = styled.div`
  -webkit-overflow-scrolling: touch;
  border-bottom: 1px solid #646464;
  overflow-x: scroll;
  padding: 0 16px 0 8px;
  white-space: nowrap;
  ${(props) => props.theme.mediaQueries.tablet`
    overflow-x: auto;
  `}
`
const Category = styled(Button).attrs({
  variant: "text",
})`
  display: inline-block;
  padding: 12px;
`

const ImageGrid = styled(Flex).attrs({
  gutter: 1,
})`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  overflow: auto;
`
const DesignImage = styled(Image)`
  background-color: ${(props) => props.theme.colors.black};
  cursor: pointer;
  width: 100%;
`

const InternalBoxDesign = ({ boxDimensions, boxDesigns, selectDesign }) => {
  const [selectedCategory, setCategory] = useState(0)

  return (
    <>
      <h4>Select a category</h4>
      <Categories data-cy="product-box-design-category">
        {boxDesigns.map((category, index) => (
          <Category
            color={selectedCategory == index ? "selected" : "neutral"}
            data-cy={`product-box-design-category-${category.name}`}
            key={`box_category_${category.id}`}
            onClick={() => setCategory(index)}
          >
            {category.name}
          </Category>
        ))}
      </Categories>
      <h4>Choose a design</h4>
      <ImageGrid data-cy="product-box-design-image">
        {boxDesigns[selectedCategory].designs.map((design) => (
          <Button
            key={`box_design_${design.id}`}
            mb={2}
            onClick={() => selectDesign(design)}
            variant="text"
            width={{ _: "50%", tablet: "33.333%" }}
          >
            <DesignImage
              alt={design.name}
              ratio="auto 1024 / 1024"
              src={imageLookup(
                "design",
                `${boxDimensions.design_file_prefix}${design.name}_${boxDimensions.box_width}_${boxDimensions.box_height}`,
                "simple"
              )}
            />
          </Button>
        ))}
      </ImageGrid>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    boxDesignOption: state.wizard.data?.box?.options?.find(
      (opt) => opt.selected_type == "design"
    ),
    boxDesigns: state.boxDesigns,
    boxDimensions: state.wizard.data?.box?.design,
  }
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { boxDesignOption, boxDimensions } = stateProps
  const { dispatch } = dispatchProps

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    selectDesign: (design) => {
      let opt = boxDesignOption
      opt.value = opt.design_value = `${boxDimensions.design_file_prefix}${design.name}_${boxDimensions.print_box_width}_${boxDimensions.print_box_height}`
      dispatch(updateChoice("box", opt, true))
      storePref(
        "design_box",
        `${boxDimensions.design_file_prefix}${design.name}`
      )
      closeModal()
    },
  }
}

InternalBoxDesign.propTypes = {
  boxDesignOption: PropTypes.object,
  boxDesigns: PropTypes.array,
  boxDimensions: PropTypes.object,
  selectDesign: PropTypes.func,
}

const BoxDesign = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalBoxDesign)

export default BoxDesign
